import React, { useEffect, useState } from 'react';
import Drawer from '@mui/material/Drawer';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { TextField } from "@mui/material";
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as Yup from "yup";
import _ from "lodash"
import ImageUploading from "react-images-uploading";
import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "@mui/material";
import { getUserDetails, userProfilePictureRemove, userProfilePictureUpdate, userProfileUpdate } from '../../../api/casp/user';
import { editProfile } from '../../../store/actions';
import { AcceptProfileFileType } from '../../../constants/Common';
import ImageCropper from '../../Profile/ImageCropper';
import { dataURLtoFile, getUrl } from '../../../helpers/file_helper';
import { MemberIcon } from '../../../constants/MemberIcon';
import { contactCreate, updateContact } from '../../../api/casp/contact';
import { Modules } from '../../../constants/Module';
import { uploadLogo } from '../../../api/casp/document';

const AddTeamMemberDrawer = ({ isOpenProfileDetail, toggle, projectId, refresh, selectedRow, t }) => {
    const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
    const [userDetails, setUserDetails] = useState();
    const [croppedImage, setCroppedImage] = useState(null);
    const [profilePicture, setProfilePicture] = useState();
    const loggedInUser = useSelector((state) => state.Profile.user);
    const [isLoading, setIsLoading] = useState(false);
    const [userObject, setUserObject] = useState({
        firstName: "",
        lastName: "",
        email: "",
        contactNo: "",
        position: "",
        profilePicture: '',
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [profile, setProfile] = useState();
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [update, setUpdate] = useState(0)
    const dispatch = useDispatch();

    const phoneRegExp = /^\+?[0-9]([0-9]|(-(?!-)))*[0-9]$/;
    const formikValidation = Yup.object().shape({
        firstName: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .max(250, t("First name can not be greater than 250 characters"))
            .required(t("Please enter first name")),
        lastName: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .max(250, t("Last name can not be greater than 250 characters"))
            .required(t("Please enter last name")),
        email: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .email(t("Please enter valid email"))
            .required(t("Please enter email")),
        contactNo: Yup.string()
            .strict(true)
            .matches(phoneRegExp, t("Contact no is not valid")).optional(),
        position: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .optional()
    });

    const formik = useFormik({
        initialValues: {
            ...userObject,
        },
        validationSchema: formikValidation,
        validateOnMount: true,
    });

    useEffect(() => {
        if (selectedRow) {
            formik.setValues(selectedRow)
            setProfilePicture(selectedRow?.profilePicture)
            setUpdate(update + 1)
        }
    }, [selectedRow])

    const fetchUserDetails = async () => {
        try {
            setIsLoading(true)
            const res = await getUserDetails(loggedInUser.id)
            if (res.statusCode === 200) {
                setUserDetails(res.data.data)
                const data = {
                    firstName: res.data.data?.firstName ?? '',
                    lastName: res.data.data?.lastName ?? '',
                    email: res.data.data?.email ?? '',
                    contactNo: res.data.data?.contactNo ?? '',
                    position: res.data.data?.position ?? '',
                    profilePicture: res.data.data.profilePicture,
                }
                setProfilePicture(res.data.data.profilePicture)
                formik.setValues(data)
                setUserObject(data)
            }
            setIsLoading(false)
        } catch (e) {
            toast.error(e)
        }
    }

    const handelCreate = async () => {
        try {
            setIsLoading(true)
            const paylaod = {
                firstName: formik.values.firstName,
                lastName: formik.values.lastName,
                email: formik.values.email,
                projectId,
            }
            const response = selectedRow ? await updateContact(selectedRow?.id, {
                ...paylaod,
                contactNo: formik.values.contactNo ? formik.values.contactNo : null,
                position: formik.values.position ? formik.values.position : null,
            }) : await contactCreate({
                ...paylaod,
                ...(formik.values.contactNo && {
                    contactNo: formik.values.contactNo,
                }),
                ...(formik.values.position && {
                    position: formik.values.position,
                })
            })
            let isFile = false
            if (response.statusCode === 200) {
                if (formik.values.profilePicture && profile) {
                    const formData = new FormData();
                    formData.append('logo', formik.values.profilePicture);
                    formData.append('moduleId', response.data.data.id);
                    formData.append('module', Modules.CONTACT);
                    formData.append('updateField', 'profilePicture')
                    const result = (await uploadLogo(formData)).data.data;
                    isFile = true
                }
                if (isFile || (!profile && !isFile)) {
                    toast.success(response.data.message);
                    refresh()
                    handleClose()
                }
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setIsLoading(false)
        }
    }

    const openEditProfileDrawer = () => {
        setIsEditDrawerOpen(true)
    }

    const closeEditProfileDrawer = () => {
        setIsEditDrawerOpen(false)
        toggle(false)
        formik.resetForm();
        formik.setValues(formik.initialValues);
    }
    const handleEdit = async () => {
        try {
            const data = _.omit(userObject, 'profilePicture')
            setIsLoading(true);
            if (croppedImage) {
                await handleProfilePictureEdit(data)
            }
            if (!croppedImage && userObject.profilePicture && !profilePicture) {
                await handleProfilePictureRemove(data)
            }
            if (!_.isEqual(data, _.omit(formik.values, 'profilePicture'))) {
                const address = {
                    ...(formik.values.address.addressLine !== '' && {
                        addressLine: formik.values.address.addressLine
                    }),
                    ...(formik.values.address.zipCode !== '' && {
                        zipCode: formik.values.address.zipCode
                    }),
                    ...(formik.values.address.state !== '' && {
                        state: formik.values.address.state
                    }),
                    ...(formik.values.address.city !== '' && {
                        city: formik.values.address.city
                    }),
                    ...(formik.values.address.country !== '' && {
                        country: formik.values.address.country
                    }),
                }
                const response = await userProfileUpdate(userDetails?.id, {
                    firstName: formik.values.firstName,
                    lastName: formik.values.lastName,
                    ...((formik.values.department.trim()) && {
                        department: formik.values.department
                    }),
                    ...(!_.isEmpty(address) && {
                        address,
                    }),
                    contactNo: formik.values.contactNo,
                    companyId: userDetails?.company.id,
                    ...(userDetails?.addressId && {
                        addressId: userDetails?.addressId
                    })
                });
                if (response.statusCode === 200) {
                    toast.success(response.data.message);
                    setIsLoading(false);
                    closeEditProfileDrawer();
                    let user = loggedInUser
                    user.name = response.data.data.name
                    dispatch(editProfile(user))
                }
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleProfilePictureEdit = async (data) => {
        try {
            const formData = new FormData();
            const file = dataURLtoFile(croppedImage, profile[0].file.name)
            formData.append('file', file);
            const response = await userProfilePictureUpdate(userDetails.id, formData);
            if (response.statusCode === 200) {
                if (_.isEqual(data, _.omit(formik.values, 'profilePicture'))) {
                    toast.success(response.data.message);
                    closeEditProfileDrawer();
                }
                fetchUserDetails()
                let user = loggedInUser
                user.profilePicture = response.data.data.profilePicture
                dispatch(editProfile(user))
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleProfilePictureRemove = async (data) => {
        try {
            const response = await userProfilePictureRemove(userDetails.id);

            if (response.statusCode === 200) {
                if (_.isEqual(data, _.omit(formik.values, 'profilePicture'))) {
                    toast.success(response.data.message);
                    closeEditProfileDrawer();
                }
                fetchUserDetails()
                let user = loggedInUser
                user.profilePicture = null
                dispatch(editProfile(loggedInUser))
            } else {
                toast.error(response.data.message);
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleClose = () => {
        setProfilePicture()
        setCroppedImage()
        setProfile()
        formik.resetForm()
        toggle(false)
    };

    return (
        <>
            {isOpenProfileDetail &&
                <Drawer anchor="right" open={isOpenProfileDetail} onClose={handleClose} className='tenantDetailsDrawer viewProDetails'>
                    <div className='responsiveDrawer p-3'>
                        <div className='profileDrawerHeader d-flex justify-content-between'>
                            <h5>{selectedRow?.id ? t('Edit Member') : t('Add Member')}</h5>
                            <CloseIcon className="crossIcon" onClick={handleClose} />
                        </div>
                        <div className='profileDrawerContentprofileDrawerContentEdit'>
                            <div className="custom-image-upload d-flex justify-content-center mb-2" key={update}>
                                <div className="image-placeholder position-relative">
                                    {!croppedImage && !profilePicture &&
                                        <Avatar
                                            className='profileAvatar' {...MemberIcon(formik?.values.firstName ? `${formik.values?.firstName} ${formik.values?.lastName}` : '')}
                                        />
                                    }
                                    {(croppedImage || profilePicture) &&
                                        <img
                                            src={croppedImage ?? getUrl(profilePicture)}
                                            alt=''
                                            className={`rounded-circle header-profile-user`}
                                        />
                                    }
                                    <ImageUploading
                                        value={profile}
                                        onChange={(newImage) => {
                                            setDialogOpen(true);
                                            formik.setFieldValue('profilePicture', newImage[0]?.file)
                                            setProfile(newImage);
                                        }}
                                        acceptType={AcceptProfileFileType}
                                        maxFileSize={1024 * 1024 * 10}
                                    >
                                        {({ onImageUpload, onImageUpdate, errors }) => (
                                            <>
                                                <label htmlFor="profile_photo" className="editIconBox position-absolute">
                                                    <EditIcon onClick={profile ? onImageUpload : () => onImageUpdate(0)}
                                                    />
                                                </label>
                                                {errors && <div>
                                                    {errors.acceptType && toast.error('Your selected file type is not allow')}
                                                    {errors.maxFileSize && toast.error('Selected file size exceed maximum file size: 10 MB')}
                                                </div>
                                                }
                                            </>
                                        )}
                                    </ImageUploading>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("First Name")}
                                        variant="outlined"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="firstName"
                                        value={t(formik.values?.firstName)}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={isLoading}
                                        required
                                    />
                                    {formik.touched.firstName && formik.errors.firstName && (
                                        <span className="text-danger">{formik.errors.firstName}</span>
                                    )}
                                </div>
                                <div className="col-sm-6 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Last Name")}
                                        variant="outlined"
                                        type="text"
                                        size="small"
                                        fullWidth
                                        name="lastName"
                                        value={formik.values?.lastName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={isLoading}
                                        required
                                    />
                                    {formik.touched.lastName && formik.errors.lastName && (
                                        <span className="text-danger">{formik.errors.lastName}</span>
                                    )}
                                </div>
                                <div className="col-sm-12 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Email")}
                                        name="email"
                                        variant="outlined"
                                        type="email"
                                        size="small"
                                        required
                                        fullWidth
                                        value={formik.values?.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={isLoading}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <span className="text-danger">{formik.errors.email}</span>
                                    )}
                                </div>
                                <div className="col-sm-6 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Phone")}
                                        variant="outlined"
                                        type="phone"
                                        size="small"
                                        fullWidth
                                        name="contactNo"
                                        value={formik.values?.contactNo}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={isLoading}
                                    />
                                    {formik.touched.contactNo && formik.errors.contactNo && (
                                        <span className="text-danger">{formik.errors.contactNo}</span>
                                    )}
                                </div>
                                <div className="col-sm-6 mb-3">
                                    <TextField
                                        id="outlined-basic"
                                        label={t("Postion")}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        name="position"
                                        value={formik.values?.position}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        disabled={isLoading}
                                    />
                                    {formik.touched.position && formik.errors.position && (
                                        <span className="text-danger">{formik.errors.position}</span>
                                    )}
                                </div>
                                <div className="plsubmitButton">
                                    <Button
                                        className="btn addNew_ProjectBtn"
                                        type="submit"
                                        disabled={isLoading || !formik.isValid || (!croppedImage && _.isEqual(_.omit(userObject, 'profilePicture'), _.omit(formik.values, 'profilePicture')) && (userObject.profilePicture === profilePicture))}
                                        onClick={handelCreate}
                                    >
                                        {t('Submit')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>


                    {isOpenSweetAlert && (
                        <SweetAlert
                            title="Are you sure want to remove your profile picture?"
                            warning
                            showCancel
                            confirmButtonText="Yes, delete it!"
                            confirmBtnBsStyle="success"
                            cancelBtnBsStyle="danger"
                            onConfirm={() => {
                                setCroppedImage()
                                setProfilePicture()
                                setIsOpenSweetAlert(false);
                            }}
                            onCancel={() => {
                                setIsOpenSweetAlert(false)
                            }}>
                        </SweetAlert>
                    )}
                </Drawer>
            }
            {dialogOpen &&
                <ImageCropper
                    open={dialogOpen}
                    handleClose={() => setDialogOpen(false)}
                    image={profile && profile?.length > 0 && profile[0]?.dataURL}
                    userId={selectedRow?.id}
                    onComplete={(imagePromisse) => {
                        imagePromisse.then((image) => {
                            setDialogOpen(false);
                            setCroppedImage(image)
                        });
                    }}
                    containerStyle={{
                        position: "relative",
                        width: "100%",
                        height: 300,
                        background: "#333"
                    }}
                />
            }

        </>
    );
}

export default withTranslation()(AddTeamMemberDrawer)
